import { CSSProperties, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { Property } from 'csstype'

import { CUSTOM_PROPS_NOT_FOR_DOM } from 'constants/global'
import { flex } from 'styles/themeUtils'

type FlexBoxProps = Partial<{
  direction: Property.FlexDirection
  justify: Property.JustifyItems
  align: Property.AlignItems
  wrap: Property.FlexWrap
  flex: Property.Flex
  gap: Property.Gap
  colGap: Property.ColumnGap
  rowGap: Property.RowGap
  height: Property.Height
  responsive: boolean
  fullWidth: boolean
  halfWidth: boolean
  style: CSSProperties
  className: string
  children: ReactNode
  onClick: () => void
}>

const Container = styled.div.withConfig({
  shouldForwardProp: prop => !CUSTOM_PROPS_NOT_FOR_DOM.includes(prop),
})<FlexBoxProps>`
  ${({ direction, align = 'normal', justify = 'normal', wrap }) => flex(direction, align, justify, wrap)}
  flex: ${props => props.flex || '0 1 auto'};
  height: ${props => props.height || 'auto'};
  gap: ${props => (props.gap ? props.gap : null)};
  row-gap: ${props => (props.rowGap ? props.rowGap : null)};
  column-gap: ${props => (props.colGap ? props.colGap : null)};
  ${props =>
    props.halfWidth
      ? css`
          width: 50%;
        `
      : ''}
  ${props =>
    props.fullWidth
      ? css`
          width: 100%;
        `
      : ''}
`

const FlexBox = ({ className, children, wrap, ...rest }: FlexBoxProps) => (
  <Container className={className} {...rest}>
    {children}
  </Container>
)

export default FlexBox
